import React, { useState, useEffect } from 'react'
import { ConnectWebSocketForOverlay, SetSocketMessageHandler, ClearSocketMessageHandler, DisconnectWebSocket } from './../../utilities/BL/Zones'
import { InteractiveChat as InteractiveChatOverlay } from './Overlays/InteractiveChat' // El componente hijo
import { GetInteractiveChatConfig } from './../../utilities/BL/InteractiveChat'

const InteractiveChat = () => {
    const [messageData, setMessageData] = useState(null); // { text: "..." } o null
    
    // Configuración por defecto
    const [config, setConfig] = useState({
        textColor: '#FFFFFF',
        strokeColor: '#000000',
        hasBackground: true,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        scale: 1.0,
        positionY: 100,
        rotation: 0,
        fontFamily: 'Montserrat'
    });

    useEffect(() => {
        // Forzar transparencia para OBS
        document.body.style.backgroundColor = 'transparent';
        document.documentElement.style.backgroundColor = 'transparent';
        const rootElement = document.getElementById('root');
        if (rootElement) rootElement.style.backgroundColor = 'transparent';

        return () => {
            document.body.style.backgroundColor = '';
            document.documentElement.style.backgroundColor = '';
            if (rootElement) rootElement.style.removeProperty('background-color');
        };
    }, []);

    useEffect(() => {
        const connect = async () => {
            // Cargar configuración persistida de la BD al iniciar
            const res = await GetInteractiveChatConfig();
            if (res.success && res.data) {
                setConfig(prev => ({ ...prev, ...res.data }));
            }

            await ConnectWebSocketForOverlay('interactive_chat', () => {}, (msg) => console.log(msg));
            SetSocketMessageHandler(handleIncomingMessage);
        };

        const handleIncomingMessage = (message) => {
            if (!message || !message.type) return;

            if (message.type.toLowerCase() === 'interactive_chat') {
                const payload = message.data;

                if (payload.action === 'show') {
                    setMessageData({ text: payload.text });
                } else if (payload.action === 'hide') {
                    setMessageData(null);
                } else if (payload.action === 'config') {
                    // Mezclamos lo existente con lo nuevo que llegue
                    setConfig(prev => ({ ...prev, ...payload.config }));
                }
            }
        };

        connect();
        return () => { ClearSocketMessageHandler(); DisconnectWebSocket(); };
    }, []);

    return (
        <InteractiveChatOverlay data={messageData} config={config} />
    );
};

export { InteractiveChat };